import { render, staticRenderFns } from "./ControlSliderTab.vue?vue&type=template&id=3783519c&scoped=true"
import script from "./ControlSliderTab.vue?vue&type=script&lang=ts"
export * from "./ControlSliderTab.vue?vue&type=script&lang=ts"
import style0 from "./ControlSliderTab.vue?vue&type=style&index=0&id=3783519c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783519c",
  null
  
)

export default component.exports